import React from 'react'
import { useNavigate } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import { healthFacilitiesUpdate1 } from '../../utils/helper';

const HealthFacilityStatus = () => {
    const navigate = useNavigate();

    const headers = ['Sl. No.', 'DISTRICT', 'HEALTH  FACILITY  NAME', 'HEALTH  FACILITY  STATUS']

    return (
        <div className="role-container">
            <div className="filters-container">
                <button onClick={() => navigate(-1)} className="filter-button"><FaHome /> Home</button>
                <span style={{ fontSize: '35px' }}>HEALTH FACILITY LIST COVERED UNDER MIDORI-CMHA</span>
                <div style={{ opacity: 0 }} className="filter-container"></div>
            </div>
            <div style={{ marginTop: 20 }} className="fm-item-container">
                <table className="fm-item-table">
                    <thead>
                        <tr>
                            {headers.map((th, idx) => {
                                return (
                                    <th key={idx} style={{ backgroundColor: '#217cc070' }}>{th}</th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {healthFacilitiesUpdate1?.map((item, idx) => {
                            return (
                                <tr key={idx}>
                                    <td>{item?.id}</td>
                                    <td>{item?.district}</td>
                                    <td>{item?.facility_name}</td>
                                    <td>{item?.type}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default HealthFacilityStatus